<template>
  <div>
    <v-row>
      <span v-show="false">{{title}}</span>
      <v-col cols="12" md="3" v-if="financialYear.warehouse_system === 'd'">
        <profit-margin-card report_type="net"></profit-margin-card>
      </v-col>
      <v-col cols="12" :md="(financialYear.warehouse_system === 'd')?3:6">
        <profit-margin-card report_type="gross"></profit-margin-card>
      </v-col>
      <v-col cols="12" md="6" v-if="financialYear.warehouse_system === 'd'">
        <month-profit-margin-chart></month-profit-margin-chart>
      </v-col>
    </v-row>
    <v-row>
    <v-col cols="12" md="6">
      <cost-chart></cost-chart>
    </v-col>
    <v-col cols="12" md="6">
      <cost-and-benefit></cost-and-benefit>
    </v-col>
    <v-col cols="12" md="6">
      <net-interest-margin-chart report_type="net"></net-interest-margin-chart>
    </v-col>
    <v-col cols="12" md="6">
      <net-interest-margin-chart report_type="gross"></net-interest-margin-chart>
    </v-col>
    </v-row>
  </div>
</template>
<script>

import CostAndBenefit from "@/views/reports/CostAndBenefitChart";
import CostTable from "@/views/reports/CostTable";
import NetInterestMarginChart from "@/views/modulePages/reportModule/NetInterestMarginChart";
import ProfitMarginCard from "@/views/modulePages/reportModule/ProfitMarginCard";
import MonthProfitMarginChart from "@/views/modulePages/reportModule/MonthProfitMarginChart";
import CostChart from "@/views/modulePages/reportModule/CostChart";
export default {
  name: "ReportHome",
  components: {
    CostChart,
    MonthProfitMarginChart,
    ProfitMarginCard,
    NetInterestMarginChart,
    CostTable,
    CostAndBenefit
  },
  props: {
    id: {},
  },
  data() {
    return {
    }
  },
  computed:{
    title(){
      return this.setDocumentTitle('داشبورد گزارشات')
    }
  }

}
</script>

<style scoped lang="scss"></style>

